import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";

const useCreateKlydoLabelsBulkMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { texts: string[] }) => {
      return await klydoApiClient.createKlydoLabelsBulk(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["klydo-labels"] });
    },
    onError: (error) => {
      console.error("Failed to create klydo labels in bulk:", error);
    },
  });
};

export default useCreateKlydoLabelsBulkMutation;
